import { NgClass, NgFor, NgIf } from "@angular/common";
import { ChangeDetectorRef, Component, EventEmitter, Input, Output } from "@angular/core";
import { SvgIconComponent } from "../svg-icon/svg-icon.component";

export type TabType = { id: string, icon?: string, label: string, subtitle?: string, disabled?: boolean };

@Component({
  selector: "app-vertical-tabs",
  standalone: true,
  imports: [NgFor, NgIf, SvgIconComponent, NgClass],
  templateUrl: "./vertical-tabs.component.html",
  styleUrl: "./vertical-tabs.component.scss"
})

export class VerticalTabsComponent {
  @Input() tabs: TabType[] = [];
  @Input() selectedTabId: string = "";
  @Output() tabSelected = new EventEmitter<string>();

  constructor(private cdr: ChangeDetectorRef) {
  }



  ngAfterViewInit() {
    if (this.tabs?.length > 0) {
      this.selectTab(this.selectedTabId || this.tabs[0].id);
      this.cdr.detectChanges();
    }
  }

  selectTab(tabId: any) {
    // console.log("Container List", this.containerList)
    const tab = this.tabs.find((tab) => tab.id === tabId);

    if(!tab) {
      console.warn(`Invalid tab id: ${tabId}`);
      return;
    }

    if(tab?.disabled){
      return;
    }
    this.selectedTabId = tab.id;
    this.tabSelected.emit(tabId);
  }
}
